import PropTypes from 'prop-types';
import React from 'react';

import CloseIcon from '../../assets/close.svg';
import Button from '../../shared/Button/Button';
import styles from './SendErrorModal.module.scss';

const SendErrorModal = ({ closeModal }) => {
  return (
    <div className={styles['modal-body']} id="send-error-modal">
      <img
        className={styles['close-icon']}
        onClick={closeModal}
        src={CloseIcon}
      />
      <div className={styles.header}>We’re Sorry</div>
      <div>
        <p>
          Something went wrong on our side. Please try sending your message
          again or{' '}
          <a
            href="https://www.troweprice.com/personal-investing/help/contact-us.html"
            id="send-error-contact-us"
            rel="noopener noreferrer"
            target="_blank"
          >
            contact us.
          </a>
        </p>
      </div>
      <Button
        className={`${styles['link-button']} close-modal branded-button`}
        onClick={closeModal}
      >
        Okay
      </Button>
    </div>
  );
};

SendErrorModal.propTypes = {
  closeModal: PropTypes.func
};

export default SendErrorModal;
